import {Button, Text} from '@chakra-ui/react';
import {FC} from 'react';
import {ICategories} from 'types';
import LinkUI from 'ui/LinkUI';

interface IProps extends ICategories {
  activeCategory: boolean;
  setActiveCategory: (value: string) => void;
}

export const ItemNav: FC<IProps> = ({activeCategory, setActiveCategory, id, name}) => {
  return (
    <LinkUI href={`#category-${id}`}>
      <Button
        onClick={() => setActiveCategory(`category-${id}`)}
        as="a"
        display="flex"
        alignItems="center"
        justifyContent="center"
        id={`#category-${id}`}
        h={['30px', '45px']}
        border="none"
        variant={activeCategory ? 'primary' : 'ghost'}
        px="12px"
        _focus={{border: 'none'}}
      >
        <Text fontSize={['12px', '16px']} lineHeight="20px">
          {name}
        </Text>
      </Button>
    </LinkUI>
  );
};
